import React from 'react';
import { Building2, Calendar, Eye, Hash, MapPin, Target } from 'lucide-react';

const About = () => {
  const legalItems = [
    { icon: Calendar, label: 'Registration Date', value: 'January 2026' },
    { icon: Hash, label: 'Registration Number', value: '8894' },
    { icon: Building2, label: 'Registrar', value: 'Registrar of NGOs, Tanzania' },
    { icon: MapPin, label: 'Postal Address', value: 'P.O Box 11189, Dar es Salaam' },
  ];

  const orgStats = [
    { title: 'Est. 2026', subtitle: 'Registered NGO network' },
    { title: 'Dar es Salaam', subtitle: 'Head office location' },
    { title: 'National', subtitle: 'Disaster coordination platform' },
  ];

  return (
    <div className="min-h-screen bg-[#0d1b2a] text-white">
      <main className="relative overflow-hidden border-b border-cyan-400/20 bg-slate-900 py-20 pt-32">
        <div className="pointer-events-none absolute inset-0">
          <div className="absolute left-10 top-10 h-40 w-40 rounded-full bg-cyan-400/10 blur-3xl" />
          <div className="absolute right-8 top-20 h-48 w-48 rounded-full bg-sky-400/10 blur-3xl" />
          <div className="absolute bottom-6 left-1/3 h-36 w-36 rounded-full bg-teal-300/10 blur-3xl" />
        </div>

        <div className="relative max-w-6xl mx-auto px-6">
          <p className="inline-flex items-center rounded-full border border-cyan-400/40 bg-cyan-400/10 px-4 py-1 text-xs font-semibold uppercase tracking-[0.2em] text-cyan-300">
            About Us
          </p>

          <h1 className="mt-5 text-4xl font-bold leading-tight text-white md:text-5xl">
          Disaster Management Non Government Organizations Network <span className="text-cyan-400">(DINGONET)</span>
          </h1>

          <div className="mt-5 h-1 w-40 rounded-full bg-gradient-to-r from-cyan-400 via-sky-300 to-transparent" />

          <p className="mt-6 max-w-3xl text-lg leading-relaxed text-gray-200">
            A professional coordination platform for humanitarian and disaster management actors in Tanzania.
          </p>
        </div>
      </main>

      <section className="py-16 bg-[#0d1b2a]">
        <div className="max-w-6xl mx-auto px-6 grid gap-8 lg:grid-cols-2">
          <div>
            <h2 className="text-3xl font-semibold text-cyan-400">Organizational Overview</h2>
            <p className="mt-5 text-gray-200 leading-8">
            Disaster Management Non-Government Organization Network (DINGONET) is the registered Tanzania NGO network No:
             ooNGO/R/8894. It brings together more than 20   national and international NGOs dealing with disaster management 
             and humanitarian action in Tanzania. The network serves as collaborative platform for coordination, joint planning, 
             information sharing and advocacy, ensuring that disaster affected communities receive timely, effective and well-
             coordinated support.
            </p>
            <p className="mt-4 text-gray-200 leading-8">
              {/* The network serves as a collaborative platform for coordination, joint planning, information sharing,
              and advocacy, ensuring that disaster-affected communities receive timely, effective, and well-coordinated
              support. */}
            </p>
          </div>

          <aside className="rounded-2xl border border-slate-700 bg-slate-800/60 p-6">
            <p className="text-xs font-semibold uppercase tracking-[0.2em] text-cyan-400">Network Snapshot</p>
            <div className="mt-5 flex flex-wrap gap-4">
              {orgStats.map((stat) => (
                <div key={stat.title} className="bg-slate-800/60 border border-slate-700 rounded-lg px-4 py-2">
                  <p className="text-white font-semibold">{stat.title}</p>
                  <p className="text-sm text-gray-300">{stat.subtitle}</p>
                </div>
              ))}
            </div>
          </aside>
        </div>
      </section>

      <section className="py-16 bg-slate-900/50 border-y border-slate-800">
        <div className="max-w-6xl mx-auto px-6">
          <h2 className="text-3xl font-semibold text-cyan-400">Legal Status</h2>
          <p className="mt-4 max-w-3xl text-gray-200 leading-8">
            DINGONET operates as a formally registered non-governmental organization in the United Republic of
            Tanzania.
          </p>

          <div className="mt-8 grid gap-4 md:grid-cols-2">
            {legalItems.map(({ icon: Icon, label, value }) => (
              <article key={label} className="bg-slate-800 rounded-xl p-5 flex items-start gap-3 border border-slate-700">
                <Icon className="w-5 h-5 text-cyan-400 mt-0.5 shrink-0" />
                <div>
                  <p className="text-xs text-gray-400 uppercase tracking-[0.12em]">{label}</p>
                  <p className="text-white font-medium mt-1">{value}</p>
                </div>
              </article>
            ))}
          </div>
        </div>
      </section>

      <section className="py-16 bg-[#0d1b2a]">
        <div className="max-w-6xl mx-auto px-6">
          <h2 className="text-3xl font-semibold text-cyan-400">Background and Rationale</h2>
          <div className="mt-6 rounded-2xl border-l-4 border-cyan-400 bg-slate-800/40 p-6 md:p-8">
            <p className="text-5xl text-cyan-400/50 leading-none">"</p>
            <p className="mt-3 text-gray-200 leading-8">
            Tanzania continues to experience a growing number of natural and human-induced disasters, including floods, droughts, 
            disease outbreaks, fires, refugee influxes, landslides, and climate-related emergencies. These disasters frequently 
            affect vulnerable populations, disrupt livelihoods, damage infrastructure, and place immense pressure on humanitarian 
            systems and local communities. Despite the presence of government institutions, humanitarian organizations, civil society
             organizations, UN agencies, faith-based organizations, and community structures working in disaster response and 
             humanitarian action, the humanitarian landscape in Tanzania still faces significant coordination and operational challenges, 
             which  contributed to the delayed response interventions, inefficient utilization of resources, weak referral systems, poor
              information management, limited accountability to affected populations, inconsistent standards in service delivery; and 
              inadequate inclusion of protection and gender-sensitive approaches. Recognizing this gap, DINGONET was established as a 
              neutral coordination body to provide professional, inclusive and structured platform through which can effectively share 
              timely information before, during and after emergencies among humanitarian stakeholder, hence enhance collective preparedness
               and response efforts and provide efficient use of resources to better support disaster affected communities.
            </p>
           
          </div>
        </div>
      </section>

      <section className="py-16 bg-slate-900/50 border-t border-slate-800">
        <div className="max-w-6xl mx-auto px-6">
          <h2 className="text-3xl font-semibold text-cyan-400">Vision &amp; Mission</h2>

          <div className="mt-8 grid gap-6 lg:grid-cols-2">
            <article className="rounded-2xl p-[1px] bg-gradient-to-br from-cyan-400/60 to-sky-400/20">
              <div className="h-full rounded-2xl bg-slate-800/90 p-6">
                <div className="inline-flex h-10 w-10 items-center justify-center rounded-lg bg-cyan-400/10 border border-cyan-400/40 text-cyan-400">
                  <Eye className="w-5 h-5" />
                </div>
                <h3 className="mt-4 text-2xl font-semibold text-white">Vision</h3>
                <p className="mt-3 text-gray-200 leading-8">
                  To become a leading unified force for disaster management and humanitarian action in Tanzania.
                </p>
              </div>
            </article>

            <article className="rounded-2xl p-[1px] bg-gradient-to-br from-cyan-400/60 to-sky-400/20">
              <div className="h-full rounded-2xl bg-slate-800/90 p-6">
                <div className="inline-flex h-10 w-10 items-center justify-center rounded-lg bg-cyan-400/10 border border-cyan-400/40 text-cyan-400">
                  <Target className="w-5 h-5" />
                </div>
                <h3 className="mt-4 text-2xl font-semibold text-white">Mission</h3>
                <p className="mt-3 text-gray-200 leading-8">
                  To strengthen disaster preparedness, response, and recovery through enhanced coordination
               and information sharing among humanitarian actors in Tanzania.
                </p>
              </div>
            </article>
          </div>
        </div>
      </section>
    </div>
  );
};

export default About;

